import { Box, Collapse, IconButton, Paper, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, TextField, Typography, useTheme, ListItemButton, Menu, MenuItem, TablePagination, TableSortLabel, Skeleton, InputAdornment, Theme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CustomDropdown from '../../../lib/formik/CustomDropdown'
import { ActionIcon, DialogCloseIcon, DropDownIcons, ExportIcon, SearchIcon, SideDropDownIcon } from '../../../assets/SvgIcons'
import IconCustomeDropDown from '../../../lib/formik/IconsCustomeDropDown';
import { useHistory } from 'react-router';
import { off } from 'process';
import { formatCurrency, maskInfo, toINR } from '../../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { setClientCode } from '../../../redux-store/actions/investorProfile';
import _ from 'lodash';
import { storeSelectedPortfolio } from '../../../redux-store/actions/portfolioFilter';
import { getAccountsExportData } from '../../../redux-store/actions/userManagement';
import { reportDownload } from '../../Reports/report-utils';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../../redux-store/reducers';
import { NO_DATA_AVAILABLE } from '../../../utils/constant';

// const TableCell = styled(MuiTableCell)({
//     width: '50px',
//     // background: 'red'
// })

interface AccountProps {
    isLoading: boolean
    accountTable: {
        individual: Array<RowProps>,
        family: Array<RowProps>
    },
    aumAmount: number,
    error: boolean,
    exportData: any;
}

export interface RowProps {
    familyName?: string,
    customerName?: string,
    portfolioName?: string,
    name?: string,
    // portfolioName: string,
    child?: boolean,
    list?: Array<RowProps>,
    ofBook?: number,
    investedValue?: number,
    marketValue?: number,
    unrealised?: number,
    unrealisedPercentage?: number,
    cash?: number,
    irr?: number,
    id?: number,
    clickable?: boolean,
    family?: boolean,
    clientCode?: string,
    portfoiloId?: string,
    familyCode?: string,
}

interface Sorting { name: string, order: "asc" | "desc" | undefined }


export default function Account(props: AccountProps) {
    const { isLoading, accountTable, aumAmount, error, exportData } = props
    const { palette } = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory()
    const state = history.location.state as { accountFilter?: number }


    const [tableData, setTableData] = useState<any[]>([])
    const [rowOption, setRowOption] = useState<number>(5)
    const [rowArray, setRowArray] = useState<number[]>([])
    const [currentPage, setCurrentPage] = useState<number>(0)
    const [searchInput, setSearchInput] = useState<string>('');
    const [exportLoad, setExportLoad] = useState<boolean>(false);
    const [sorting, setSorting] = useState<Sorting>({
        name: '',
        order: 'asc',
    })
    const dispatch = useDispatch();
    const style: any = { color: palette.text.secondary, fontWeight: 500, fontSize: '14px', textTransform: 'uppercase', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }

    useEffect(() => {
        const dummy = tableData?.length <= 5 ? [5] : tableData?.length <= 10 ? [5, 10] : tableData?.length <= 15 ? [5, 10, 15] : [5, 10, 15, 20]
        setRowArray(dummy)
    }, [tableData])

    console.log('tableData', tableData)

    useEffect(() => {
        const dummy = [...((accountTable?.individual) || [])]
        setTableData(dummy)
    }, [accountTable])


    const handlePageChange = (event: any, page: number) => {
        setCurrentPage(page);
    }

    const handleRow = (row: string | number) => {
        setRowOption(parseInt(row as string))
        setCurrentPage(0)
        setSearchInput('')
    }

    const handleSorting = (name: string) => {
        setCurrentPage(0)

        setSorting((preSorting) => {
            const preNameSort = preSorting.name === name;

            return { name: name, order: preNameSort ? (preSorting.order === 'asc' ? 'desc' : 'asc') : preSorting.order }
        })
    }

    const handleSearch = (value: string) => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput(value)
    }

    const handleCancelSearch = () => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput('')
    }

    const handleExport = async () => {
        setExportLoad(true)
        try {
            const formatExportedData = [
                {
                    "navDate": "NAV DATE",
                    "familyName": "FAMILY NAME",
                    "customer": "CUSTOMER",
                    "customerName": "CUSTOMER NAME",
                    "activationDate": "ACTIVATION DATE",
                    "portfolio": "PORTFOLIO",
                    "portfolioName": "PORTFOLIO NAME",
                    "startDate": "START DATE",
                    "netAssets": "NET ASSETS",
                    "capital": "CAPITAL",
                    "cashBalance": "CASH BALANCE",
                    "cashflow": "CASH FLOW",
                    "unrelGainLoss": "UNREALISED GAIN LOSS",
                    "return": "RETURN",
                    "WtAvgDays": "WT. AVG DAYS",
                    "isPfInvestExists": "IS PF INVEST EXISTS",
                },
                ...exportData
            ]
            const exportRes = (await dispatch(getAccountsExportData({ jsonData: formatExportedData, sheetName: 'AUM Distribution' }))) as unknown as any;
            reportDownload(exportRes as unknown as Blob, 'AUM Distribution.xlsx');
            enqueueSnackbar('File downloaded successfully.', {
                variant: 'success',
                autoHideDuration: 2000,
            });

        } catch (err) {
            console.log('err', err)
            enqueueSnackbar('File download failed!.', {
                variant: 'error',
                autoHideDuration: 2000,
            });
        }
        setExportLoad(false)
    }

    return (
        <>
            <Box component={'section'} style={{
                width: '100%',
                padding: '25px 30px',
                borderRadius: 20,
                background: '#ffffff',
                boxShadow: `0px 4px 10px 0px ${palette.background.default}`,
                marginTop: '15px'
            }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: { lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }, rowGap: '20px' }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-start', md: 'flex-start', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        <Typography variant='h2' sx={{
                            fontWeight: 600,
                            fontSize: 20,
                            color: palette.text.primary
                        }}>
                            Investor Details
                        </Typography>
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        <IconButton sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '5px',
                            alignItems: 'center',
                            padding: '2px 0px',
                            cursor: 'pointer',
                            "&:hover": { backgroundColor: "transparent" }

                        }}
                            disableFocusRipple={true}
                            onClick={exportLoad ? () => null : () => handleExport()}
                        >
                            <ExportIcon />
                            <Typography variant="body_400">Export</Typography>
                        </IconButton>
                        <Box>
                            <TextField
                                // autoFocus
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{
                                                    display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                                }}
                                                onClick={handleCancelSearch}
                                            >
                                                <DialogCloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: (theme: Theme) => ({
                                        borderRadius: '57px',
                                        height: '47.17px',
                                        border: `1px solid ${theme.palette.text.secondary}B2`,
                                        // marginTop: '20px',
                                        width: '100%',
                                        maxWidth: '204px',
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '& input': {
                                            paddingLeft: '10px',
                                            ...theme.typography.body_500,
                                            color: theme.palette.text.primary,
                                            '::placeholder': {
                                                ...theme.typography.subtitle_400,
                                                color: theme.palette.text.secondary,
                                                opacity: 1,
                                            },
                                        },
                                    }),
                                }}
                                placeholder="Search"
                                value={searchInput}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleSearch(event.target.value);
                                }}
                            />

                        </Box>
                    </Box>
                </Box>

                <TableContainer style={{ padding: '35px 15px 25px 15px' }}>
                    <Table aria-label="collapsible table" style={{ tableLayout: "auto" }}>
                        <TableHead sx={{ display: "table-header-group" }}>
                            <TableRow >
                                <TableCell style={{ ...style, paddingLeft: '15px' }}>
                                    <TableSortLabel active={('familyName') === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('familyName')}>Name</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }}>
                                    <TableSortLabel active={'marketValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('marketValue')}>% of book</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }}>
                                    <TableSortLabel active={'investedValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('investedValue')}>invested value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'marketValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('marketValue')}>market value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'unrealised' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('unrealised')}>unrealised <br /> return %</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'cash' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('cash')}>cash Available</TableSortLabel>
                                </TableCell>
                                <TableCell align='left' style={{ ...style }} >
                                    <TableSortLabel active={'irr' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('irr')}>Absolute Return %</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? <TableLoader row={5} column={8} /> : null}
                            {error ?
                                <TableRow>
                                    <TableCell colSpan={8}>
                                        <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                                    </TableCell>
                                </TableRow> : null
                            }
                            {!error ?
                                <>
                                    {(_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => row.customerName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).map((row, i) => (
                                        <Row key={i + row?.portfolioName} row={row} border={false} child={false} right={false} aumAmount={aumAmount} />
                                    ))}
                                    {!isLoading && (_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => row.customerName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).length === 0 ?
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                                            </TableCell>
                                        </TableRow> : null
                                    }
                                </> : null
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={rowArray}
                        component="div"
                        count={_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => row.customerName?.toLowerCase().includes(searchInput?.toLowerCase())).length}
                        rowsPerPage={rowOption}
                        page={currentPage}
                        labelRowsPerPage={"Rows per page:"}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={(e) => handleRow(e.target.value)}
                        sx={{
                            color: palette.text.primary[500]
                        }} />
                </TableContainer>
            </Box >
        </>
    )
}



function Row(props: { row: RowProps | undefined, border?: boolean, child: boolean, right?: boolean, clickable?: boolean | undefined, aumAmount: number }) {
    const { row, border, child, right, clickable, aumAmount } = props;
    const [open, setOpen] = React.useState(false);
    const { palette } = useTheme()
    const history = useHistory()
    const dispatch = useDispatch()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const style = { color: palette.text.primary, fontWeight: 500, padding: 0 }

    const handleClick = () => {

        dispatch(setClientCode((row?.clientCode || "") as string))
        dispatch(storeSelectedPortfolio({ label: '', value: '' }))

        // if (!child) {
        //     history.push(`/family-profile/${(maskInfo(row?.familyName || ""))}`, {
        //         familyName: (row?.familyName || "") as string,
        //     })
        // } else {
        history.push(`/investor-profile/${row?.customerName}`, {
            clientCode: (row?.clientCode || "") as string,
            portfoiloId: row?.portfoiloId || "",
        })
        // }
    }

    return (
        <>
            <TableRow style={{
                borderLeft: (child || open) ? `3px solid ${palette.primary[500]}` : '3px solid transparent',
                padding: border ? '10px 0px' : '0px',
                margin: border ? '10px 0px' : '0px',
            }}>
                <TableCell
                    onClick={(e) => (!child && row?.familyName === 'not applicable') ? null : handleClick()}
                    sx={{
                        opacity: (!child && row?.familyName === 'not applicable') ? 0.5 : 1,
                    }}
                    component="th" scope="row" style={{
                        padding: right ? '0px 30px' : '0px 8px',
                        color: palette.primary[500],
                        fontWeight: 500,
                        textTransform: 'capitalize',
                        cursor: 'pointer'
                    }}>
                    {row?.child &&
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation()
                                setOpen(!open)
                            }}
                        >
                            {!open ? <SideDropDownIcon /> : <DropDownIcons />}
                        </IconButton>
                    }
                    {!row?.child && <IconButton size='small' style={{ backgroundColor: 'transparent' }} disableRipple={true} >
                        <SideDropDownIcon opacity={10} style={{ opacity: 0 }} />
                    </IconButton>}
                    {child ?
                        (row?.list?.length as number) > 0 ?
                            row?.customerName?.toLowerCase()
                            : maskInfo(row?.portfolioName || '')?.toLowerCase()
                        : row?.familyName === 'Not Applicable' ?
                            row?.customerName?.toLowerCase()
                            : maskInfo((row?.customerName || '')?.toLowerCase())} {`${(row?.list?.length as number) > 0 ? `(${row?.list?.length})` : ''}`}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {(((row?.marketValue as number) / aumAmount) * 100)?.toFixed(2)}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.investedValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.investedValue ?? 0, locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.marketValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (row?.marketValue ?? 0), locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style, color: (row?.unrealised as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.unrealised as number >= 0 ? '' : '-'}{formatCurrency({ value: Math.abs(row?.unrealised as number), locale, currencyCode })} {row?.investedValue ? `(${(((row?.unrealised as number) / (row?.investedValue as number)) * 100).toFixed(2)}%)` : ''}</TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.cash as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.cash ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.cash ?? 0, locale, currencyCode })}`}
                </TableCell>
                <TableCell align="left" style={{ ...style, color: (row?.irr as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.irr?.toFixed(2)}</TableCell>
                <TableCell align="center" style={{ ...style }}>
                    <IconCustomeDropDown data={row} filterValue={1} isToggle={child} />
                </TableCell>
            </TableRow >
            {(row?.child && open) &&
                row?.list?.map((item, i) => (
                    <Row key={i} row={item} border={false} child={true} right={true} aumAmount={aumAmount} />
                ))
            }
        </>
    );
}


function TableLoader(props: { row: number, column: number }) {
    const { row = 5, column = 8 } = props
    return (
        <>
            {[...Array(row)].map((_, index) => (
                <TableRow key={index} sx={{ '& > *': { borderBottom: 'unset' } }} style={{
                    borderLeft: 'none',
                    padding: '0px',
                    margin: '0px',
                    transitionTimingFunction: 'ease-in'
                }}>

                    {[...Array(column)].map((_, index) => (

                        <TableCell
                            key={index}
                            component="th"
                            scope="row"
                            style={{
                                padding: '0px 8px',
                                color: 'transparent',
                                fontWeight: 500,
                                textTransform: 'capitalize',
                                cursor: 'pointer'
                            }}
                        >
                            <Skeleton
                                variant="text"
                                animation="wave"
                                sx={{
                                    padding: '10px 0px',
                                    borderRadius: "7px"
                                }}
                            />
                        </TableCell>
                    ))}

                </TableRow>
            ))}
        </>
    )
}